import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col-12 col-md-12" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = {
  class: "ms-0",
  style: {"width":"85%"}
}
const _hoisted_4 = { class: "ms-auto" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Ambil Data ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "col-12 col-md-12" }
const _hoisted_10 = { class: "col-12 col-md-6" }
const _hoisted_11 = { class: "col-12 col-md-6" }
const _hoisted_12 = { class: "col-12 col-md-4" }
const _hoisted_13 = { class: "col-12 col-md-4" }
const _hoisted_14 = { class: "d-flex align-items-center gap-2" }
const _hoisted_15 = { class: "col-md-4" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" AD Value ")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle ms-2 fs-7",
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "top",
  title: `Berdasarkan master data media`
}, null, -1)
const _hoisted_18 = { class: "col-12 col-md-12" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-align-justify text-white" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Fix OCR Text ")

import { IMedkon } from "@/global-helper/data-structure";
import { ref, watch, computed } from "vue";
import ApiService from "@/core/services/ApiService";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { useRouter } from "vue-router";
import { checkNews } from "../streams";
import { formatDateTime } from "@/global-helper/handler";

interface IProps {
  form: IMedkon;
  type: string;
  refreshupload: boolean;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    form: { type: null, required: true },
    type: { type: String, required: true },
    refreshupload: { type: Boolean, required: true }
  },
  setup(__props: any) {

const props = __props as {
  form: IMedkon;
  type: string;
  refreshupload: boolean;
}

const router = useRouter();
const form = ref<any>(props.form);
const type = ref(props.type);
const render_upload = ref(true);
const get_data_button = ref<HTMLElement | null>(null);

const is_enable_field = ref(type.value == "add");
const is_enable_field_url = computed(() => {
  return type.value == "add" ? false : true;
});
const is_enable_field_check_url = computed(() => {
  return type.value == "add" ? false : true;
});
const is_enable_field_content = computed(() => {
  return false;
});

const sentiment_options = ref([
  { value: null, label: "Tidak Ada", icon: "" },
  { value: 1, label: "Positif", icon: "far fa-smile fs-2x text-success" },
  { value: 0, label: "Netral", icon: "far fa-meh text-primary fs-2x" },
  { value: -1, label: "Negatif", icon: "far fa-frown text-danger fs-2x" },
]);

const checkContent = async () => {
  is_enable_field.value = false;
  get_data_button.value?.setAttribute("data-kt-indicator", "on");
  get_data_button.value?.setAttribute("disabled", "disabled");

  form.value.content = "";
  form.value.account = "";
  form.value.title = "";
  form.value.date = "";
  form.value.journalist = "";
  form.value.ad_value = 0;

  let params = {
    url: form.value.file_source.trim(),
  };
  let response = await checkNews(params);

  if (response["error"] || response["result"].error) {
    Swal.fire({
      text: "Gagal Mendapatkan Informasi Berita ! Silahkan Masukkan URL Berita Lain...",
      icon: "error",
      confirmButtonText: "Ok",
      buttonsStyling: false,
      customClass: {
        confirmButton: "btn btn-light-primary",
      },
    });
  } else {
    const data = response["result"];
    if (data.siputra.status) {
      Swal.fire({
        title: "Berita ditemukan di database SIPUTRA!",
        html: "Apakah anda ingin mengubah berita tersebut?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Tidak",
        confirmButtonText: "Ya, Ubah",
        allowOutsideClick: false,
        width: "500px",
      }).then(async (result) => {
        if (result.value) {
          goToRoute(data.siputra.data._id, "berita-edit", false);
        } else {
          form.value.file_source = "";
        }
      });
    } else if (data.scraper.status) {
      Swal.fire({
        title: "Berita ditemukan di database SCRAPER!",
        html: "Apakah anda ingin mengubah berita tersebut?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Tidak",
        confirmButtonText: "Ya, Ubah",
        allowOutsideClick: false,
        width: "500px",
      }).then(async (result) => {
        if (result.value) {
          const scrap_data = data.scraper.data;
          form.value.is_scraper_edit = true;
          form.value.id = scrap_data._id;
          form.value.content = scrap_data.content;
          form.value.account = scrap_data.account;
          form.value.title = scrap_data.title;
          form.value.date = formatDateTime(scrap_data.date);
          form.value.journalist = scrap_data.journalist;
          is_enable_field.value = false;
        } else {
          form.value.file_source = "";
        }
      });
    } else {
      getContentUrl();
    }
    get_data_button.value?.removeAttribute("data-kt-indicator");
    get_data_button.value?.removeAttribute("disabled");
  }
};
const normalizeUrl = (url: string) => {
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }
  return "https://" + url;
};

const getContentUrl = () => {
  let url = "/crawler/newspaper";

  ApiService.post(url, {
    data: { url: form.value.file_source.trim() },
  })
    .then((response) => {
      if (response.status == 200) {
        form.value.id = "";
        form.value.content = response.data.content;
        form.value.account = response.data.account;
        form.value.title = response.data.title;
        form.value.date = formatDateTime(response.data.date);
        form.value.journalist = response.data.journalist;
      } else {
        if (form.value.file_source) {
          const subdomain = new URL(normalizeUrl(form.value.file_source))
            .hostname;
          form.value.account = subdomain;
        }
        is_enable_field.value = false;
      }
    })
    .catch((error) => {
      Swal.fire({
        text: "Gagal Mendapatkan Informasi Berita ! Silahkan Masukkan URL Berita Lain...",
        icon: "error",
        confirmButtonText: "Ok",
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-light-primary",
        },
      });
      if (form.value.file_source) {
        const subdomain = new URL(normalizeUrl(form.value.file_source))
          .hostname;
        form.value.account = subdomain;
      }
      is_enable_field.value = false;
    });
};

const checkAdValue = () => {
  let url = `/media?media_like=${form.value.account}&limit=100&page=1&source=${form.value["source"]}`;
  ApiService.get(url)
    .then((response) => {
      form.value.ad_value = response.data.data.ad_value || 0;
    })
    .catch((error) => {
      form.value.ad_value = 0;
    });
};

const goToRoute = (id: string, name: string, detail: boolean) => {
  if (detail) {
    window.open("/berita/detail/" + id);
  } else {
    router.push({ name: name, params: { id: id } });
  }
};

const convertText = () => {
  if (form.value.content != null) {
    let text = form.value.content.split("\n\n");
    let newText = "";

    for (let i = 0; i < text.length; i++) {
      let perTextArray = text[i].split("\n");
      for (let j = 0; j < perTextArray.length; j++) {
        if (perTextArray[j].charAt(perTextArray[j].length - 1) == "-") {
          newText += perTextArray[j].replace(/-/g, "");
        } else {
          newText += perTextArray[j] + " ";
        }
      }
      newText += "\n";
    }
    form.value.content = newText;
  }
};

watch(
  () => form.value.account,
  () => {
    checkAdValue();
  },
  { immediate: true }
);

watch(props, () => {
  if (props.refreshupload) {
    render_upload.value = false;

    setTimeout(() => {
      render_upload.value = true;
      props.refreshupload = false;
    }, 200);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form_item, {
        label: "URL Berita",
        prop: "file_source",
        rules: {
        required: true,
        message: 'URL Berita Wajib Diisi',
        trigger: ['blur', 'change'],
      }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_input, {
                type: "text",
                placeholder: "URL Berita",
                modelValue: form.value.file_source,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.file_source) = $event)),
                disabled: _unref(is_enable_field_url),
                onBlur: _cache[1] || (_cache[1] = ($event: any) => (form.value.file_source = form.value.file_source.trim()))
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary btn-lg btn-block",
                onClick: checkContent,
                ref: (_value, _refs) => {
                  _refs['get_data_button'] = _value
                  get_data_button.value = _value
                },
                disabled: _unref(is_enable_field_check_url)
              }, _hoisted_8, 8, _hoisted_5)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_el_form_item, {
        label: "Judul Berita",
        prop: "title",
        rules: {
        required: true,
        message: 'Judul Berita Wajib Diisi',
        trigger: ['blur', 'change'],
      }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            type: "text",
            placeholder: "Judul Berita",
            modelValue: form.value.title,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.title) = $event)),
            rows: "2",
            disabled: is_enable_field.value,
            onBlur: _cache[3] || (_cache[3] = ($event: any) => (form.value.title = form.value.title.trim()))
          }, null, 8, ["modelValue", "disabled"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_el_form_item, {
        label: "Nama Media",
        prop: "account",
        rules: {
        required: true,
        message: 'Nama Media Wajib Diisi',
        trigger: ['blur', 'change'],
      }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            type: "text",
            modelValue: form.value.account,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.account) = $event)),
            placeholder: "Media",
            disabled: true,
            onBlur: _cache[5] || (_cache[5] = ($event: any) => (form.value.account = form.value.account.trim()))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_el_form_item, {
        label: "Tanggal Berita",
        prop: "date",
        rules: {
        required: true,
        message: 'Tanggal Berita Wajib Diisi',
        trigger: ['blur', 'change'],
      }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_date_picker, {
            style: {"width":"100% !important"},
            modelValue: form.value.date,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.date) = $event)),
            placeholder: "Tanggal Berita",
            format: "YYYY-MM-DD HH:mm:ss",
            "value-format": "YYYY-MM-DD HH:mm:ss",
            name: "date",
            type: "datetime",
            disabled: is_enable_field.value
          }, null, 8, ["modelValue", "disabled"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_el_form_item, {
        label: "Jurnalis",
        prop: "journalist",
        rules: {
        required: false,
        message: 'Jurnalis Wajib Diisi',
        trigger: ['blur', 'change'],
      }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            type: "text",
            modelValue: form.value.journalist,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.journalist) = $event)),
            placeholder: "Jurnalis",
            disabled: is_enable_field.value,
            onBlur: _cache[8] || (_cache[8] = ($event: any) => (form.value.journalist = form.value.journalist?.trim()))
          }, null, 8, ["modelValue", "disabled"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_el_form_item, {
        label: "Sentimen",
        prop: "sentiment",
        rules: {
        required: false,
        message: 'Sentimen Wajib Diisi',
        trigger: ['blur', 'change'],
      }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            class: "form-control-custom",
            modelValue: form.value.sentiment,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.sentiment) = $event)),
            placeholder: "Sentimen"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sentiment_options.value, (options) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: options.value,
                  label: options.label,
                  value: options.value
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_14, [
                      _createElementVNode("i", {
                        class: _normalizeClass(options.icon)
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(options.label), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_el_form_item, {
        label: "AD Value",
        prop: "ad_value",
        rules: {
        required: true,
        message: 'AD Value Wajib Diisi',
        trigger: ['blur', 'change'],
      }
      }, {
        label: _withCtx(() => [
          _hoisted_16,
          _hoisted_17
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            type: "number",
            modelValue: form.value.ad_value,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.ad_value) = $event)),
            placeholder: "Ad Value",
            disabled: is_enable_field.value
          }, null, 8, ["modelValue", "disabled"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(_component_el_form_item, {
        label: "Konten Berita",
        prop: "content",
        rules: {
        required: true,
        message: 'Konten Berita Wajib Diisi',
        trigger: ['blur', 'change'],
      }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            type: "textarea",
            modelValue: form.value.content,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.content) = $event)),
            rows: "10",
            disabled: _unref(is_enable_field_content),
            onBlur: _cache[12] || (_cache[12] = ($event: any) => (form.value.content = form.value.content.trim()))
          }, null, 8, ["modelValue", "disabled"]),
          _createVNode(_component_el_button, {
            size: "small",
            class: "btn btn-sm btn-primary my-5",
            type: "primary",
            onClick: convertText
          }, {
            default: _withCtx(() => [
              _hoisted_19,
              _hoisted_20
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})